module.exports = __webpack_public_path__ + "img/es.99603929.svg";